<template>
  <div>
    <b-container class="wide">
      <head-block :title="$t('title.customer.product_sheets')" />
      <!--      Comment this OUT if we decide that customers can print barcodes-->
      <!--      <iframe-->
      <!--        id="label-print-frame"-->
      <!--        v-if="labelPrintLink"-->
      <!--        style="display:none"-->
      <!--        :src="labelPrintLink"></iframe>-->
      <b-row align-h="between">
        <b-col
          class="align-self-center"
          cols="auto"
        >
          <b-button
            variant="success"
            class="mr-2 mb-2"
            @click="$bvModal.show('add-product-sheet')">
            <b-icon icon="plus-circle"></b-icon>
            {{ $t('table.product_sheets.button_create') }}
          </b-button>
          <b-button
            class="mb-2"
            v-if="Object.keys(customerData).length && !customerData.campaign && !customerData.campaignRequestName"
            variant="info"
            @click="$bvModal.show('request-campaign-add')">
            {{ $t('table.product_sheets.button_request_campaign_add') }}
          </b-button>
          <b-button
            v-else-if="Object.keys(customerData).length && customerData.campaign && !customerData.campaignRequestName"
            class="mb-2"
            variant="danger"
            @click="showConfirmModal(customerData, 'request-campaign-remove')">
            {{ $t('table.product_sheets.button_request_campaign_remove') }}
          </b-button>
        </b-col>

        <b-col
          class="align-self-center mb-2"
          cols="auto"
        >
          <search-field
            v-model="searchString"
            @search="getProductSheetList"
          />
        </b-col>
        <b-col
          class="mb-2"
          cols="auto"
        >
          <b-button
            @click="showFilter = !showFilter"
            variant="primary">
            <b-icon icon="filter" scale="1.3"></b-icon>
            {{ $t('table.general.button_filters') }}
          </b-button>
        </b-col>
      </b-row>

      <div v-if="showFilter">
        <product-sheet-filter
          @filter-applied="updateProductSheetsWithFilter"
        />
      </div>
      <content-table
        :fields="fields"
        :items="userProductSheets"
        :slots="templates"
        :primary-key="primaryKey"
        :defaultSortDesc="sortDesc"
        :defaultSortBy="sortBy"
        head-variant="dark"
      >
        <template slot="status" slot-scope="data">
          <div class="d-flex justify-content-center">
            {{ getObjectByKeyValue(productSheetStatuses, 'code', data.tbl.item.status).name }}
          </div>
        </template>
        <template
          slot="created"
          slot-scope="data"
        >{{
          formatDateTime(data.tbl.item.createdAt, userMarket?.supportCountry?.code, userMarket?.timezone)
        }}</template>
        <template slot="actions" slot-scope="data">
          <div class="d-flex justify-content-center">
            <!--      Comment this OUT if we decide that customers can print barcodes-->
            <!--            <b-button-->
            <!--              size="sm"-->
            <!--              class="mr-1"-->
            <!--              v-if="!editableStatuses.includes(data.tbl.item.status)"-->
            <!--              v-b-tooltip.hover-->
            <!--              :title="$t('table.product_sheets.button_print')"-->
            <!--              variant="info"-->
            <!--              @click="printProductSheet(data.tbl.item)">-->
            <!--              <font-awesome-icon icon="print" size="lg"/>-->
            <!--            </b-button>-->
            <b-button
              size="sm"
              v-if="editableStatuses.includes(data.tbl.item.status)"
              class="mr-1"
              v-b-tooltip.hover
              :title="$t('table.product_sheets.button_update_products')"
              variant="primary"
              @click="$router.push({name: 'product-sheet-details', params: {productSheetId: data.tbl.item.id}})">
              <b-icon icon="pencil-square"></b-icon>
            </b-button>
            <b-button
              v-else
              size="sm"
              class="mr-1"
              v-b-tooltip.hover
              :title="$t('table.product_sheets.button_view_products')"
              variant="warning"
              @click="$router.push({name: 'product-sheet-details', params: {productSheetId: data.tbl.item.id}})">
              <b-icon icon="view-stacked"></b-icon>
            </b-button>
            <b-button
              size="sm"
              class="mr-1"
              v-b-tooltip.hover
              v-if="userMarket?.customerAccessToProductCompletion && editableStatuses.includes(data.tbl.item.status) && data.tbl.item.hasProducts"
              :title="$t('table.product_sheets.button_complete')"
              variant="success"
              @click="checkProductSheetValidity(data.tbl.item)">
              <b-icon icon="check-square"></b-icon>
            </b-button>
            <b-button
              size="sm"
              v-b-tooltip.hover
              v-if="editableStatuses.includes(data.tbl.item.status)"
              :title="$t('table.general.button_delete')"
              variant="danger"
              @click="showConfirmModal(data.tbl.item, 'delete-item')">
              <b-icon icon="trash"></b-icon>
            </b-button>
          </div>
        </template>
      </content-table>
      <span v-if="!loader.isActive && !userProductSheets.length" class="no-table-data">
        {{ $t('table.general.no_data') }}
      </span>
      <div
        v-if="pagesCount > 1"
        class="pagination_div">
        <paginate
          :value="page"
          :page-count="pagesCount"
          container-class="pagination-container"
          page-class="page-item"
          prev-class="btn btn-primary"
          next-class="btn btn-primary"
          active-class="active-class"
          :click-handler="clickPaginationCallback" />
      </div>
      <add-product-sheet-modal
        modalId="add-product-sheet"
      />
      <request-campaign-modal
        modalId="request-campaign-add"
        v-if="userMarket && customerData"/>
      <!--      Comment this OUT if we decide that customers can print barcodes-->
      <!--      <print-product-sheet-modal-->
      <!--        modalId="print-product-sheet"-->
      <!--        @label-print="labelPrint"-->
      <!--        v-if="customerData && selectedObject"-->
      <!--        :customer="customerData"-->
      <!--        :productSheet="selectedObject"/>-->
      <confirm-item-modal
        modalId="delete-item"
        :okButtonTitle="$t('modal.general.ok_button')"
        :cancelButtonTitle="$t('modal.general.cancel_button')"
        :title="$t('modal.product_sheets.title_delete')"
        :text="$t('modal.product_sheets.text_delete')"
        @onConfirm="confirmObjectAction(
          $_actionTypes.DELETE_USER_PRODUCT_SHEET,
          'id',
          $t('notifications.text.product_sheets.success_product_sheet_deleted'),
        )"/>
      <confirm-item-modal
        v-if="userMarket?.customerAccessToProductCompletion"
        modalId="complete-product-sheet"
        :okButtonTitle="$t('modal.general.ok_button')"
        :cancelButtonTitle="$t('modal.general.cancel_button')"
        :title="$t('modal.product_sheets.title_complete')"
        :text="(selectedObject && selectedObject.status === draftStatus)
          ? $t('modal.product_sheets.text_complete_draft', { systemName })
          : $t('modal.product_sheets.text_complete', { systemName })"
        @onConfirm="completeProductSheet"/>
      <confirm-item-modal
        modalId="request-campaign-remove"
        :okButtonTitle="$t('modal.general.ok_button')"
        :cancelButtonTitle="$t('modal.general.cancel_button')"
        :title="$t('modal.product_sheets.title_request_campaign_removal')"
        :text="$t('modal.product_sheets.text_request_campaign_removal')"
        @onConfirm="confirmObjectAction(
          $_actionTypes.REQUEST_PRODUCT_CAMPAIGN_REMOVAL,
          'userNumber',
          $t('notifications.text.product_sheets.success_campaign_removal_requested'),
        )"/>
    </b-container>
  </div>
</template>

<script>

  import { mapState, mapGetters } from 'vuex'
  import ObjectUtils from '@base/mixins/ObjectUtils.vue'
  import ContentTable from '@base/components/ContentTable'
  import ConfirmItemModal from '@base/components/ConfirmItemModal.vue'
  import SearchField from '@base/components/SearchField.vue'
  import HeadBlock from '@base/components/HeadBlock.vue'
  import ObjectAction from '@base/mixins/ObjectAction.vue'
  import AddProductSheetModal from '@user/components/AddProductSheetModal.vue'
  import RequestCampaignModal from '@user/components/RequestCampaignModal.vue'
  // import PrintProductSheetModal from '@user/components/PrintProductSheetModal.vue'
  import {EDITABLE_STATUSES, PRODUCT_SHEET_STATUSES, SHEET_DRAFT, SHEET_READY} from '@base/configs'
  import { SYSTEM_NAME } from '@base/configs'
  import ProductSheetFilter from '@user/components/ProductSheetFilter.vue'
  import Formatting from "@base/mixins/Formatting.vue";

  export default {
    name: 'ProductSheetsView',

    components: {
      ProductSheetFilter,
      RequestCampaignModal,
      // PrintProductSheetModal,
      HeadBlock,
      AddProductSheetModal,
      ConfirmItemModal,
      SearchField,
      ContentTable,
    },

    mixins: [ ObjectAction, ObjectUtils, Formatting ],

    data () {
      return {
        primaryKey: 'id',
        sortBy: 'createdAt',
        sortDesc: true,
        fields: [
          { key: 'name', label: this.$t('table.product_sheets.name'), class: 'text-center', sortable: true },
          { key: 'description', label: this.$t('table.product_sheets.description'), class: 'text-center', sortable: true },
          { key: 'status', label: this.$t('table.product_sheets.status'), class: 'text-center', sortable: true },
          { key: 'createdAt', label: this.$t('table.product_sheets.created_at'), class: 'text-center', sortable: true },
          { key: 'actions', label: this.$t('form.general.actions'), class: 'text-center' }
        ],
        templates: [
          { name: 'created', field: 'createdAt' },
          { name: 'status', field: 'status' },
          { name: 'actions', field: 'actions' },
        ],
        searchString: null,
        showFilter: false,
        filters: {},
        selectedObject: null,
        loading: false,
        systemName: SYSTEM_NAME,
        draftStatus: SHEET_DRAFT,
        readyStatus: SHEET_READY,
        editableStatuses: EDITABLE_STATUSES,
        productSheetStatuses: PRODUCT_SHEET_STATUSES,
        // labelPrintLink: null,
      }
    },

    created () {
      this.getProductSheetList()
    },

    computed: {
      ...mapState(['userProductSheets', 'customerData', 'userMarket']),
      ...mapGetters({
        page: 'getUserProductSheetsPage',
        pagesCount: 'getUserProductSheetsPagesCount'
      }),
    },

    methods: {

      clickPaginationCallback (pageNum) {
        if (this.loading)
          return
        this.loading = true
        this.loader = this.$loading.show(this.$_loaderOptions)

        this.$store.commit(this.$_mutationTypes.SET_PRODUCT_SHEET_PAGE, pageNum)
        this.$store.dispatch(this.$_actionTypes.GET_USER_PRODUCT_SHEET_LIST)
          .then((res) => {
            this.$store.commit(this.$_mutationTypes.SET_PRODUCT_SHEET_PAGES_COUNT, res.totalPages)
          })
          .catch((error) => {
            this.$_notifyError(error, this)
          })
          .finally(() => {
            this.loader.hide()
            this.loading = false
          })
      },

      getProductSheetList () {
        if (this.loading)
          return
        this.loading = true
        this.loader = this.$loading.show(this.$_loaderOptions)
        this.$store.commit(this.$_mutationTypes.SET_PRODUCT_SHEET_PAGE, 1)
        this.$store.commit(this.$_mutationTypes.SET_PRODUCT_SHEET_FILTERS, { search: this.searchString, ...this.filters })
        this.$store.dispatch(this.$_actionTypes.GET_USER_PRODUCT_SHEET_LIST)
          .then((res) => {
            this.$store.commit(this.$_mutationTypes.SET_PRODUCT_SHEET_PAGES_COUNT, res.totalPages)
          })
          .catch((error) => {
            this.$_notifyError(error, this)
          })
          .finally(() => {
            this.loader.hide()
            this.loading = false
          })
      },

      checkProductSheetValidity (productSheetObj) {
        this.selectedObject = this.$_.cloneDeep(productSheetObj)
        this.$bvModal.show('complete-product-sheet')
      },

      completeProductSheet () {
        if (this.loading)
          return
        this.loading = true
        this.loader = this.$loading.show(this.$_loaderOptions)
        this.$store.dispatch(this.$_actionTypes.COMPLETE_USER_PRODUCT_SHEET, this.selectedObject.id)
          .then(() => {
            this.$notify({
              group: 'app',
              type: 'success',
              title: this.$t('notifications.title.success'),
              text: this.$t('notifications.text.product_sheets.success_product_sheet_completed', { systemName: this.systemName })
            })
          })
          .catch((error) => {
            this.$_notifyError(error, this)
          })
          .finally(() => {
            this.loader.hide()
            this.loading = false
          })
      },

      updateProductSheetsWithFilter (filters) {
        this.filters = filters
        this.getProductSheetList()
      },

      // printProductSheet(obj) {
      //   this.selectedObject = this.$_.cloneDeep(obj)
      //   this.$nextTick(() => {
      //     this.$bvModal.show('print-product-sheet')
      //   })
      // },
      // labelPrint (link) {
      //   if (this.loading)
      //     return
      //   this.loading = true
      //   this.loader = this.$loading.show(this.$_loaderOptions)
      //   this.$store.dispatch(this.$_actionTypes.PRINT_USER_PRODUCT_SHEET, this.selectedObject.id)
      //     .then(() => {
      //       if (link === this.labelPrintLink) {
      //         document.getElementById('label-print-frame').contentWindow.location.reload(true)
      //       } else {
      //         this.labelPrintLink = link
      //       }
      //       this.$notify({
      //         group: 'app',
      //         type: 'success',
      //         title: this.$t('notifications.title.success'),
      //         text: this.$t('notifications.text.product_sheets.success_product_sheet_printed')
      //       })
      //     })
      //     .catch((error) => {
      //       this.$_notifyError(error, this)
      //     })
      //     .finally(() => {
      //       this.loader.hide()
      //       this.loading = false
      //     })
      // }
    }
  }

</script>

<style scoped>

</style>
